import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBell,
    faUser,
    faRightFromBracket,
    faCircleQuestion,
    faIdBadge,
    faWallet,
    faQrcode,
    faUsers,
    faTableColumns,
    faUserGroup,
    faSquarePollVertical,
    faMoneyBill,
    faPeopleGroup,
    faAddressCard,

} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";



import { faUser as faUserRegular } from "@fortawesome/free-regular-svg-icons";


import { useAuth } from "../context/AuthProvider";
import logo from "../assets/tiply_logo_v5.png";

export default function EmployeeLayoutV2({ children }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const {
        currentUser,
        userData,
        venueOptions,
        activeVenue,
        clearVenueSelection,
        logout,
    } = useAuth();
    const navigate = useNavigate();



    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const handleChangeVenue = () => {
        setDropdownOpen(false);
        clearVenueSelection();
        navigate("/select-venue");
    };

    return (
        <div className="min-h-screen flex justify-center bg-[#f6f6f9] gap-x-48">
            {/* Sidebar */}
            <aside className="hidden lg:flex shrink-0 py-8 flex-col gap-6 ">
                {/*<h1 className="text-4xl font-extrabold text-green-500 tracking-wide">Tiply</h1>*/}
                <img src={logo} alt="Tiply" className="w-32 h-auto"/>

                {/*<img*/}
                {/*    src={logo}*/}
                {/*    alt="Logo"*/}
                {/*    className="h-14 w-auto mr-2"*/}
                {/*/>*/}
                <nav className="space-y-5 text-lg text-gray-700 mt-6 ml-2">
                    <SidebarItem icon={faTableColumns} label="Dashboard" onClick={() => navigate(`/profile/dashboard`)}/>
                    <SidebarItem icon={faMoneyBill} label="Payouts" onClick={() => navigate(`/profile/payouts`)}/>
                    <SidebarItem icon={faWallet} label="Tips" onClick={() => navigate(`/profile/tips`)}/>
                    <SidebarItem icon={faAddressCard} label="My Info" onClick={() => navigate(`/profile/information`)}/>
                </nav>
            </aside>

            {/* Main content wrapper */}
            <div className="flex flex-col w-full max-w-screen-md px-4">

                {/* Main Content */}
                <main className="flex-1 w-full py-6">
                    <div className="max-w-5xl mx-auto flex justify-end items-center py-4 bg-[#f6f6f9]">
                        <div className="relative" ref={dropdownRef}>
                            <div
                                className="flex items-center gap-2 cursor-pointer"
                                onClick={() => setDropdownOpen((prev) => !prev)}
                            >
                                <FontAwesomeIcon icon={faUserRegular} />
                                <span className="text-sm font-medium">{userData?.firstName + " " + userData?.lastName || "Your Name"}</span>
                                <span>{dropdownOpen ? "▲" : "▼"}</span>
                            </div>

                            {dropdownOpen && (
                                <div className="absolute right-0 top-10 w-64 bg-white shadow-lg rounded-lg p-4 text-sm z-20">
                                    {/*<p className="font-semibold mb-1">{currentUser?.displayName || "Employee"}</p>*/}
                                    {/*<p className="text-xs text-gray-500 mb-3">Tiply ID: {currentUser?.uid?.slice(0, 6) || "ID1234"}</p>*/}
                                    {/*<hr className="mb-2" />*/}
                                    <div className="px-1 pb-2 mb-2 border-b border-gray-100">
                                        <p className="font-semibold text-gray-900">{activeVenue?.businessName || "Employee account"}</p>
                                    </div>
                                    <div className="space-y-2">
                                        {/*<DropdownItem icon={faIdBadge} text="Your details" />*/}
                                        {/*<DropdownItem icon={faCircleQuestion} text="Help" />*/}
                                        {venueOptions.length > 1 && (
                                            <button
                                                onClick={handleChangeVenue}
                                                className="flex items-center gap-2 text-gray-700 hover:text-black w-full"
                                            >
                                                <FontAwesomeIcon icon={faTableColumns} />
                                                <span>Change venue</span>
                                            </button>
                                        )}
                                        <button
                                            onClick={logout}
                                            className="flex items-center gap-2 text-red-500 hover:text-red-600 w-full"
                                        >
                                            <FontAwesomeIcon icon={faRightFromBracket} />
                                            <span>Log out</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {children}
                </main>

                {/* Bottom Nav */}
                <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around py-6 z-30 shadow-sm">
                    <BottomNavItem icon={faTableColumns} label="Dashboard" onClick={() => navigate(`/profile/dashboard`)}/>
                    <BottomNavItem icon={faMoneyBill} label="Payouts" onClick={() => navigate(`/profile/payouts`)}/>
                    <BottomNavItem icon={faWallet} label="Tips" onClick={() => navigate(`/profile/tips`)}/>
                    <BottomNavItem icon={faAddressCard} label="My Info" onClick={() => navigate(`/profile/information`)}/>
                </nav>
            </div>
        </div>

    );
}

// Sidebar Item
const SidebarItem = ({ icon, label, onClick }) => (
    <div
        className="flex items-center gap-3 text-gray-700 hover:text-black cursor-pointer transition-colors"
        onClick={onClick}
    >
        <FontAwesomeIcon icon={icon} className="w-5 text-center" />
        <span>{label}</span>
    </div>
);



// Bottom Navigation Button
const BottomNavItem = ({ icon, label, onClick }) => (
    <button className="flex flex-col items-center text-xs text-gray-700 hover:text-black" onClick={onClick}>
        <FontAwesomeIcon icon={icon} className="text-lg mb-1" />
        {label}
    </button>
);

// Dropdown menu item
const DropdownItem = ({ icon, text }) => (
    <div className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">
        <FontAwesomeIcon icon={icon} />
        <span>{text}</span>
    </div>
);
